import { Component, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/services/config/config.service';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';
import { ProductType } from 'src/app/interfaces/user';

@Component({
  selector: 'app-identialert-sub-selection-modal',
  templateUrl: './identialert-sub-selection-modal.component.html',
  styleUrls: ['./identialert-sub-selection-modal.component.scss']
})
export class IdentialertSubSelectionModalComponent {
  @Input('modalRef') public modalRef: NgbModalRef;
  @Input() public isUpgrade: boolean;
  @Input() private cancelUrl?: string;

  public loading = false;
  public pricingPlans = environment.stripePlans;
  public planIdIdentiAlert = this.pricingPlans.identiAlertAnnual;
  public plan2YearlyPrice: string;
  public plan2MonthlyPrice: string;

  constructor(
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private configService: ConfigService,
    private paymentConfigService: PaymentConfigService
  ) {
    this.plan2YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ??
      this.configService.getTextFromKey('2-plan-yearly-price');
    this.plan2MonthlyPrice = this.paymentConfigService.getMonthlyDisplayPrice(
      ProductType.Premium,
      this.configService.getTextFromKey('2-plan-monthly-price')
    );
  }

  public onCloseModal() {
    this.modalRef.close();
  }

  public onSubscribeToIdentiAlert() {
    this.loading = true;

    this._checkoutService
    .checkout(
      [this.planIdIdentiAlert],
      {
        isUpgrade: this.isUpgrade,
        ...(this.cancelUrl ? { cancelUrl: this.cancelUrl } : {})
      }
    ).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      err => {
        this._logService.error('an error occured: ', err);
      }
    )
    .add(() => {
      this.loading = false;
      this.modalRef.close();
    });
  }

}
